import Tacos from "@/components/brand_portfolio/Tacos";
import LoadingElement from "@/components/shared/LoadingElement.vue";
export default {
  name: "BrandPortfolioTacosCell",
  components: {
    Tacos,
    LoadingElement
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    periodLength: {
      type: Number,
      default: 14
    },
    period_data: {
      type: Object,
      default: {}
    },
    selected_period: {
      type: String,
      default: "weekly"
    },
    isLastSellerInWorkspace: {
      type: Boolean,
      default: false
    }
  }
};